import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/site';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-lg font-heading text-foreground-950 mb-3">
              <Link to="/" className="text-foreground-950 no-underline">
                {siteConfig.logo}
              </Link>
            </h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              记录历史长河中的重大时刻，为每一个关心历史的人提供深度、准确、易读的历史事件解读。
            </p>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-3 whitespace-nowrap">事件分类</h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors no-underline"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-3 whitespace-nowrap">关于我们</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors no-underline"
                >
                  品牌故事
                </Link>
              </li>
              <li>
                <a
                  href={`mailto:${siteConfig.about.contact.email}`}
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors no-underline"
                  rel="nofollow"
                >
                  联系我们
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-3 whitespace-nowrap">联系方式</h4>
            <ul className="space-y-2">
              <li className="text-sm text-foreground-600">
                <i className="ri-mail-line mr-2"></i>
                {siteConfig.about.contact.email}
              </li>
              <li className="text-sm text-foreground-600">
                <i className="ri-map-pin-line mr-2"></i>
                {siteConfig.about.contact.address}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="border-t border-background-200/70 py-5">
        <div className="w-full px-4 md:px-6 max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} {siteConfig.name}. All rights reserved.
          </p>
          <p className="text-xs text-foreground-500">
            本站内容仅供学习和参考，不构成任何建议。
          </p>
        </div>
      </div>
    </footer>
  );
}